(function Chat($, Adzuki)
{
	"use strict";

	// eslint-disable-next-line no-unused-vars
	var ClientChat,
	    AgentChat,
	    jQuery    = $,
	    loadJqXhr = null;

	ClientChat = function ClientChat() {
		var self,
		    $chat_container,
		    $chat_name;

		this.mouseMovement = '0';

		this.setSessionCookie = function setSessionCookie(name, value) {
			var cookieName = 'clientChat_' + name;

			document.cookie = cookieName + '=' + encodeURIComponent(value) + '; path=/; ';

			return;
		};

		this.getSessionCookie = function getSessionCookie(name) {
			var cookieName = 'clientChat_' + name;

			var i;
			var valueIndex = document.cookie.indexOf(cookieName + '=');

			if (valueIndex === -1) {
				return 'N/A';
			}

			valueIndex += (cookieName.length + 1);

			for (i = valueIndex; i < document.cookie.length && document.cookie[i] !== ';'; i++) {
				// nothing to do
			}

			return decodeURIComponent(document.cookie.substr(valueIndex, (i - valueIndex)));
		};

		this.noAgentsAvailable = function noAgentsAvailable() {
			this.jc = Adzuki.CustomConfirm({
				title  : 'Confirm',
				body   : 'There are currently no agents available for you to chat<br>with.  Would you like to send the agency a message?',
				confirm: function confirm() {
					document.location.href = Adzuki.base_uri + '/ContactUs/';
				},
				cancel: function cancel() {
					return;
				},
			});

			this.close();

			return;
		};

		this.open = function open() {
			if (this.mouseMovement === '1' && this.active === 'N/A') {
				$chat_container.find('.messages').html('');

				$chat_container.find('.message-input').addClass('hidden');

				this.show();

				this.sendRequest();
			}

			return false;
		};

		this.close = function close() {
			this.end(true);

			return false;
		};

		this.show = function show() {
			clearTimeout(this.popupTimeout);

			this.setSessionCookie('popupExpires', 'POPPEDUP');

			this.setSessionCookie('active', 'true');

			this.active = 'true';

			jQuery('.chat-popup').addClass('hidden');

			$chat_container.addClass('open');

			return;
		};

		this.hide = function hide() {
			this.setSessionCookie('active', 'N/A');

			this.active = 'N/A';

			$chat_container.removeClass('open');

			return;
		};

		this.initPopup = function initPopup() {
			var popupExpires,
			    time;

			if (Adzuki.chat_popup_minutes === '0') {
				return;
			}

			popupExpires = this.getSessionCookie('popupExpires');

			if (popupExpires === 'POPPEDUP') {
				return;
			}
			else if (popupExpires === 'N/A') {
				time = parseInt(Adzuki.chat_popup_minutes) * 60000;

				this.setSessionCookie('popupExpires', ((new Date().getTime()) + time));
			}
			else {
				time = popupExpires - (new Date().getTime());
			}

			this.popupTimeout = setTimeout(function timeout() {
				jQuery('.chat-popup').removeClass('hidden');

				return;
			}, time);

			return;
		};

		this.dismissPopup = function dismissPopup() {
			this.setSessionCookie('popupExpires', 'POPPEDUP');

			jQuery('.chat-popup').addClass('hidden');

			return;
		};

		this.eventHandler = function eventHandler(eventData) {
			var self = this;

			if (window.console !== undefined) {
				console.log('Received Client Event: ' + eventData['eventType'] + ' :: ' + JSON.stringify(eventData));
			}

			switch (eventData['eventType']) {
				case 'request':
					if (this.chat.chatId === null || this.chat.chatStatus === 'ended' || this.chat.chatStatus === 'closed') {
						document.getElementById('web-chat-request-sound').play();

						if (!document.hasFocus()) {
							Adzuki.TitleAlert('Agent chat request.');
						}

						this.jc = Adzuki.CustomConfirm({
							title  : 'Confirm',
							body   : 'Agent ' + eventData['agentName'] + ' would like to chat<br>with you.  Would you like to accept?',
							confirm: function confirm() {
								self.establish(eventData['chatId']);

								self.show();
							},
							cancel: function cancel() {
								return;
							},
						});
					}
				break;
				case 'requestAccept':
					if (this.active === 'true') {
						this.establish(eventData['chatId']);
					}
				break;
				case 'messageSent':
					if (this.active === 'true') {
						this.load();

						document.getElementById('web-chat-receive-sound').play();

						if (!document.hasFocus()) {
							Adzuki.TitleAlert('New chat message received.');
						}
					}
				break;
				case 'end':
					if (this.active === 'true') {
						if (this.chat.chatStatus === 'request') {
							this.noAgentsAvailable();
						}
						else {
							this.end();
						}
					}
				break;
				default:
					// nothing to do
				break;
			}

			return;
		};

		this.setupChat = function setupChat(chatId, chatStatus) {
			this.chat = {
				chatId    : chatId,
				chatStatus: chatStatus
			};

			if (chatStatus !== 'request') {
				$chat_container.find('.message-input').removeClass('hidden');

				$chat_container.find('.chat-message').focus();
			}

			this.load();
		};

		this.sendRequest = function sendRequest() {
			var self;

			this.setSessionCookie('clientName', $chat_name.val());

			self = this;

			jQuery.ajax({
				type   : 'POST',
				url    : Adzuki.base_uri + '/Chats/sendRequest',
				data   : 'source=website&action=clientChatSendRequest&phpSessId=' + Adzuki.php_sess_id + '&clientName=' + encodeURIComponent($chat_name.val()) + '&mouseMovement=' + this.mouseMovement,
				success: function success(response) {
					var responseData = JSON.parse(response);

					if (!responseData['success']) {
						if (responseData['reason'] === 'noAgents') {
							self.noAgentsAvailable();
						}
						else {
							self.establish(responseData['chatId']);
						}

						return;
					}

					self.setupChat(responseData['chatId'], 'request');

					return;
				},
				error: function error() {
					self.noAgentsAvailable();

					return;
				}
			});

			return false;
		};

		this.load = function load() {
			var self;

			$chat_name.val($chat_name.val().trim());

			if ($chat_name.val() === '') {
				$chat_name.val('Guest');
			}

			this.setSessionCookie('clientName', $chat_name.val());

			self = this;

			jQuery.ajax({
				type   : 'POST',
				url    : Adzuki.base_uri + '/Chats/sendRequest',
				data   : 'source=website&action=clientChatLoad&phpSessId=' + Adzuki.php_sess_id + '&clientId=' + encodeURIComponent(Adzuki.client_id) + '&clientName=' + encodeURIComponent($chat_name.val()),
				success: function success(response) {
					var responseData = JSON.parse(response);

					self.chat = responseData['chat'];

					if (self.chat.chatStatus === 'active') {
						$chat_container.find('.message-input').removeClass('hidden');

						$chat_container.find('.chat-message').focus();
					}
					else {
						$chat_container.find('.message-input').addClass('hidden');
					}

					$chat_container.find('.messages').html(responseData['html']);

					if ($chat_container.find('.messages').length > 0) {
						$chat_container.find('.messages').scrollTop($chat_container.find('.messages')[0].scrollHeight);
					}

					return;
				},
				error: function error() {
					setTimeout(function timeout() {
						self.load();

						return;
					}, 1000);

					return;
				}
			});

			return;
		};

		this.establish = function establish(chatId) {
			var self;

			this.setSessionCookie('clientName', $chat_name.val());

			self = this;

			jQuery.ajax({
				type   : 'POST',
				url    : Adzuki.base_uri + '/Chats/sendRequest',
				data   : 'source=website&action=clientChatEstablish&phpSessId=' + Adzuki.php_sess_id + '&chatId=' + chatId + '&clientId=' + encodeURIComponent(Adzuki.client_id) + '&clientName=' + encodeURIComponent($chat_name.val()),
				success: function success(response) {
					var responseData = JSON.parse(response);

					if (!responseData['success']) {
						self.end(false, function end() {
							self.sendRequest();
						});

						return;
					}

					self.setupChat(chatId, 'active');

					return;
				},
				error: function error() {
					self.end(false, function end() {
						self.sendRequest();
					});

					return;
				}
			});

			return;
		};

		this.sendMessage = function sendMessage(event, sendClick) {
			var self = this,
			    $chat_message = $chat_container.find('.chat-message');

			event.stopPropagation();

			if ((event.keyCode === 13 || sendClick) && $chat_message.val().trim() !== '') {
				this.setSessionCookie('clientName', $chat_name.val());

				jQuery.ajax({
					type   : 'POST',
					url    : Adzuki.base_uri + '/Chats/sendRequest',
					data   : 'source=website&action=clientChatSendMessage&phpSessId=' + Adzuki.php_sess_id + '&chatId=' + this.chat.chatId + '&message=' + encodeURIComponent($chat_message.val()) + '&clientId=' + encodeURIComponent(Adzuki.client_id) + '&clientName=' + encodeURIComponent($chat_name.val()),
					success: function success(response) {
						var responseData = JSON.parse(response);

						if (!responseData['success']) {
							self.end();

							return;
						}

						$chat_message.val('');

						self.load();

						return;
					},
					error: function error() {
						this.jc = Adzuki.StatusMessage('error', 'Unable to send message. Please try again.');

						return;
					}
				});
			}

			return;
		};

		this.end = function end(close, callback) {
			var closeParam,
			    chatId,
			    self;

			if (close === undefined) {
				closeParam = false;
			} else {
				closeParam = close;
			}

			if (this.chat.chatId === null) {
				if (callback !== undefined) {
					callback();
				}

				if (closeParam) {
					this.hide();
				}

				return;
			}

			chatId = this.chat.chatId;

			if (this.chat.chatStatus === 'request' || closeParam) {
				this.chat.chatId = null;
			}
			else {
				$chat_container.find('.messages').html('');

				$chat_container.find('.message-input').addClass('hidden');
			}

			self = this;

			jQuery.ajax({
				type    : 'POST',
				url     : Adzuki.base_uri + '/Chats/sendRequest',
				data    : 'source=website&action=clientChatEnd&phpSessId=' + Adzuki.php_sess_id + '&chatId=' + chatId + '&clientId=' + encodeURIComponent(Adzuki.client_id) + '&clientName=' + encodeURIComponent($chat_name.val()),
				complete: function complete() {
					if (!closeParam) {
						self.load();

						if (self.chat.chatStatus === 'active') {
							self.chat.chatStatus = 'ended';

							document.getElementById('web-chat-ended-sound').play();

							if (!document.hasFocus()) {
								Adzuki.TitleAlert('Agent has left the chat.');
							}
						}
					}

					if (callback !== undefined) {
						callback();
					}

					if (closeParam) {
						self.hide();
					}
				}
			});

			return;
		};

		self = this;

		window.addEventListener('mousemove', function mousemove() {
			self.mouseMovement = '1';
		});

		$chat_container = jQuery('.chat-sidebar');
		$chat_name = $chat_container.find('.chat-name');

		jQuery('.toggle-chat').on('click', function click(e) {
			e.preventDefault();

			if (self.active === 'N/A') {
				self.open();
			}
			else {
				self.close();
			}
		});

		jQuery('.chat-popup-cancel').on('click', function click(e) {
			e.preventDefault();

			self.dismissPopup();
		});

		jQuery('.chat-popup-click').on('click', function click(e) {
			e.preventDefault();

			self.open();
		});

		$chat_container.find('.close-chat').on('click', function click(e) {
			e.preventDefault();

			self.close();
		});

		$chat_container.find('.chat-message').on('keypress', function click(e) {
			self.sendMessage(e, false);
		});

		$chat_container.find('.chat-message-button').on('click', function click(e) {
			self.sendMessage(e, true);
		});

		this.popupTimeout = null;
		this.active = this.getSessionCookie('active');

		this.chat = {
			chatId    : null,
			chatStatus: null
		};

		if (this.active === 'true') {
			this.show();

			this.load();
		}

		this.initPopup();

		return;
	};

	AgentChat = function AgentChat() {
		var self,
		    $chat_container;

		this.REQUEST_ACCEPT_TIMEOUT = 60;
		this.INACTIVITY_TIMEOUT     = 300;

		this.setSessionCookie = function setSessionCookie(name, value) {
			var cookieName = 'agentChat_' + name;

			document.cookie = cookieName + '=' + encodeURIComponent(value) + '; domain=' + Adzuki.cookie_domain + '; path=/; ';

			return;
		};

		this.getSessionCookie = function getSessionCookie(name) {
			var cookieName = 'agentChat_' + name;

			var i;
			var valueIndex = document.cookie.indexOf(cookieName + '=');

			if (valueIndex === -1) {
				return 'N/A';
			}

			valueIndex += (cookieName.length + 1);

			for (i = valueIndex; i < document.cookie.length && document.cookie[i] !== ';'; i++) {
				// nothing to do
			}

			return decodeURIComponent(document.cookie.substr(valueIndex, (i - valueIndex)));
		};

		this.getComposer = function getComposer() {
			return $chat_container.find('input.chat-message');
		};

		this.setRequestAcceptTimeout = function setRequestAcceptTimeout(chatId, time) {
			return;
		};

		this.setInactivityTimeout = function setInactivityTimeout(chatId, time) {
			return;
		};

		this.resetInactivityTimeout = this.setInactivityTimeout;

		this.activate = function activate() {
			this.setSessionCookie('active', 'true');

			this.active = 'true';

			return;
		};

		this.show = function show() {
			$chat_container.addClass('show');

			return;
		};

		this.hide = function hide() {
			this.setSessionCookie('active', 'N/A');

			this.active = 'N/A';

			$chat_container.removeClass('show');

			return;
		};

		this.open = function open() {
			if (this.active === 'N/A') {
				this.activate();

				this.load(this.tabId);
			}

			return false;
		};

		this.close = function close() {
			this.hide();

			return false;
		};

		this.eventHandler = function eventHandler(eventData) {
			if (window.console !== undefined) {
				console.log('Received Agent Event: ' + eventData['eventType'] + ' :: ' + JSON.stringify(eventData));
			}

			switch (eventData['eventType']) {
				case 'reload':
					if (eventData['stopTitleAlert'] && Adzuki.TitleAlert.running) {
						Adzuki.TitleAlert.stop();
					}

					this.load((eventData['tabId'] === null) ? this.tabId : eventData['tabId']);
				break;
				case 'messageSent':
					this.activate();

					this.load(eventData['chatId']);

					document.getElementById('cpcentral-chat-receive-sound').play();

					if (!document.hasFocus()) {
						Adzuki.TitleAlert('New chat message received.');
					}
				break;
				case 'end':
					this.activate();

					this.load(eventData['chatId']);

					document.getElementById('cpcentral-chat-ended-sound').play();

					if (!document.hasFocus()) {
						Adzuki.TitleAlert('Website visitor has left the chat.');
					}
				break;
				default:
				break;
			}

			return;
		};

		this.processAlert = function processAlert(alert) {
			var self = this;

			if (this.jc !== null && !this.jc.isClosed()) {
				this.execClearAlert = false;
				this.jc.close();
				this.jc = null;
			}

			if (alert === null) {
				return;
			}

			switch (alert['type']) {
				case 'request':
					if (this.dnd) {
						return;
					}

					document.getElementById('cpcentral-chat-request-sound').play();

					if (!document.hasFocus()) {
						Adzuki.TitleAlert('New chat request.');
					}

					this.jc = Adzuki.CustomConfirm({
						title  : alert['title'],
						body   : alert['message'],
						confirm: function confirm() {
							self.execClearAlert = false;

							self.acceptRequest(alert['chatAlertId'], alert['data']['chatId'], alert['data']['clientName']);
						},
						cancel: function cancel() {
							if (self.execClearAlert) {
								self.clearAlert(alert['chatAlertId']);
							}
							else {
								self.execClearAlert = true;
							}
						},
					});
				break;
				case 'requestFailure':
				case 'requestAcceptFailure':
					self.activate();

					this.jc = Adzuki.StatusMessage('error', alert['message']);

					if (self.execClearAlert) {
						self.clearAlert(alert['chatAlertId']);
					}
					else {
						self.execClearAlert = true;
					}
				break;
				default:
				break;
			}

			return;
		};

		this.clearAlert = function clearAlert(chatAlertId) {
			jQuery.ajax({
				type : 'POST',
				url  : Adzuki.base_uri + '/Chats/sendRequest',
				data : 'source=cpCentral&action=agentChatClearAlert&phpSessId=' + Adzuki.php_sess_id + '&chatAlertId=' + chatAlertId,
				error: function error() {
					setTimeout(this.clearAlert, 1000);

					return;
				}
			});

			return;
		};

		this.load = function load(tabId) {
			var self           = this,
			    tabIdParam     = tabId;

			if (tabIdParam === 'N/A') {
				tabIdParam = 'visitors';
			}

			this.setSessionCookie('tabId', tabIdParam);

			this.tabId = tabIdParam;

			if (this.tabId !== 'visitors' && this.tabId !== 'chat_sessions') {
				this.setSessionCookie('activeChatId', this.tabId);

				this.activeChatId = this.tabId;
			}

			if (this.activeChatId === 'N/A') {
				this.activeChatId = 0;
			}

			if (loadJqXhr !== null) {
				loadJqXhr.abort();

				loadJqXhr = null;
			}

			loadJqXhr = jQuery.ajax({
				type   : 'POST',
				url    : Adzuki.base_uri + '/Chats/sendRequest',
				data   : 'source=cpCentral&action=agentChatLoad&phpSessId=' + Adzuki.php_sess_id + '&tabId=' + encodeURIComponent(tabIdParam) + '&activeChatId=' + encodeURIComponent(this.activeChatId),
				success: function success(response) {
					var responseData        = JSON.parse(response),
					    $composer           = self.getComposer(),
					    typedMessage        = null,
					    selectionStart      = null,
					    selectionEnd        = null,
					    composerWasFocused  = false,
					    composerElement     = null;

					loadJqXhr = null;

					if (window.console !== undefined) {
						console.log('agentChatLoad: ' + tabIdParam);
					}

					self.dnd = responseData['dnd'];

					if (responseData['clients'] > 0) {
						jQuery('.toggle-chat').addClass('chat-icon-active');
						jQuery('.toggle-chat').addClass('nav-badge');
					}
					else {
						jQuery('.toggle-chat').removeClass('chat-icon-active');
						jQuery('.toggle-chat').removeClass('nav-badge');
					}

					self.processAlert(responseData['alert']);

					jQuery.each(self.chats, function each(chatId, chat) {
						clearTimeout(chat.requestAcceptTimeout);
						clearTimeout(chat.inactivityTimeout);
					});

					self.chats = responseData['chats'];

					jQuery.each(self.chats, function each(chatId, chat) {
						if (chat.requestAcceptExpires !== null) {
							self.setRequestAcceptTimeout(chatId, chat.requestAcceptExpires - (new Date().getTime()));
						}
						else if (chat.inactivityExpires !== null) {
							self.setInactivityTimeout(chatId, chat.inactivityExpires - (new Date().getTime()));
						}
					});

					self.chatStatus = responseData['chatStatus'];

					if ($composer.length > 0) {
						composerElement    = $composer[0];
						typedMessage       = $composer.val();
						selectionStart     = composerElement.selectionStart;
						selectionEnd       = composerElement.selectionEnd;
						composerWasFocused = (document.activeElement === composerElement);
					}

					$chat_container.html(responseData['html']);

					$chat_container.find('.hide-chat').on('click', function click(e) {
						e.preventDefault();

						self.close();

						jQuery(this).blur();
					});

					$chat_container.find('.visitors-tab').on('click', function click(e) {
						e.preventDefault();

						self.sendReloadRequest('visitors');
					});

					$chat_container.find('.chats-tab').on('click', function click(e) {
						e.preventDefault();

						self.sendReloadRequest('chat_sessions');
					});

					$chat_container.find('.messages-tab').on('click', function click(e) {
						e.preventDefault();

						self.sendReloadRequest(self.activeChatId, true);
					});

					$chat_container.find('.start-chat').on('click', function click(e) {
						e.preventDefault();

						self.sendRequest(jQuery(this).data('id'), jQuery(this).data('client-name'));
					});

					$chat_container.find('.view-chat').on('click', function click(e) {
						e.preventDefault();

						self.sendReloadRequest(jQuery(this).data('chat-id'), true);
					});

					$chat_container.find('.close-chat').on('click', function click(e) {
						e.preventDefault();

						self.closeChat(jQuery(this).data('chat-id'), true);
					});

					$chat_container.find('.chat-message').not('input, textarea').on('click', function click(e) {
						e.preventDefault();

						self.sendReloadRequest(jQuery(this).data('chat-id'), true);
					});

					self.getComposer().on('keypress', function click(e) {
						self.sendMessage(e, false);
					});

					$chat_container.find('.chat-message-button').on('click', function click(e) {
						self.sendMessage(e, true);
					});

					if ($chat_container.find('.messages').length > 0) {
						$chat_container.find('.messages').scrollTop($chat_container.find('.messages')[0].scrollHeight);
					}

					$composer = self.getComposer();

					if (typedMessage !== null && $composer.length > 0) {
						$composer.val(typedMessage);
					}

					if (
						$composer.length > 0
						&& (composerWasFocused || typedMessage === null)
					) {
						$composer.focus();
					}

					if (
						$composer.length > 0
						&& selectionStart !== null
						&& selectionEnd !== null
					) {
						$composer[0].setSelectionRange(selectionStart, selectionEnd);
					}

					$chat_container.find('.chat-toggle-dnd').on('click', function click(e) {
						var current_dnd = jQuery(this).data("dnd-status");
						e.preventDefault();

						jQuery.ajax({
							type: 'GET',
							url : Adzuki.base_uri + '/Chats/toggleDnd/' + current_dnd,
						});

						if (current_dnd === '1') {
							jQuery(this).html('Off');
							jQuery(this).data('dnd-status', '0');
						}
						else {
							jQuery(this).html('On');
							jQuery(this).data('dnd-status', '1');
						}
					});

					if (self.active === 'true') {
						self.show();
					}

					return;
				},
				error: function error(jqXhr, textStatus) {
					if (textStatus === 'abort') {
						return;
					}

					loadJqXhr = null;

					setTimeout(function timeout() {
						this.load(tabIdParam);

						return;
					}, 1000);

					return;
				}
			});

			return false;
		};

		this.reload = this.load;

		this.sendReloadRequest = function sendReloadRequest(tabId, markMessagesSeen) {
			var tabIdParam            = tabId,
			    markMessagesSeenParam;

			if (tabIdParam === 'N/A') {
				tabIdParam = 'visitors';
			}

			if (markMessagesSeen === undefined) {
				markMessagesSeenParam = false;
			}
			else {
				markMessagesSeenParam = markMessagesSeen;
			}

			jQuery.ajax({
				type : 'POST',
				url  : Adzuki.base_uri + '/Chats/sendRequest',
				data : 'source=cpCentral&action=agentChatSendReloadRequest&phpSessId=' + Adzuki.php_sess_id + '&tabId=' + encodeURIComponent(tabIdParam) + '&markMessagesSeen=' + markMessagesSeenParam,
				error: function error() {
					setTimeout(function timeout() {
						this.sendReloadRequest(tabIdParam, markMessagesSeenParam);

						return;
					}, 1000);

					return;
				}
			});

			return false;
		};

		this.closeChat = function closeChat(chatId) {
			var self = this;

			this.jc = Adzuki.CustomConfirm({
				body   : 'Are you sure you want to close this chat?',
				confirm: function confirm() {
					self.end(chatId, true, true);
				},
			});

			return false;
		};

		this.sendRequest = function sendRequest(sessionId, clientName) {
			var self = this;

			jQuery.ajax({
				type : 'POST',
				url  : Adzuki.base_uri + '/Chats/sendRequest',
				data : 'source=cpCentral&action=agentChatSendRequest&phpSessId=' + Adzuki.php_sess_id + '&sessionId=' + encodeURIComponent(sessionId) + '&clientName=' + encodeURIComponent(clientName),
				error: function error() {
					setTimeout(function timeout() {
						self.sendRequest(sessionId, clientName);

						return;
					}, 1000);

					return;
				}
			});

			return false;
		};

		this.acceptRequest = function acceptRequest(chatAlertId, chatId, clientName) {
			var self = this;

			this.activate();

			jQuery.ajax({
				type : 'POST',
				url  : Adzuki.base_uri + '/Chats/sendRequest',
				data : 'source=cpCentral&action=agentChatAcceptRequest&phpSessId=' + Adzuki.php_sess_id + '&chatAlertId=' + chatAlertId + '&chatId=' + chatId + '&clientName=' + encodeURIComponent(clientName),
				error: function error() {
					setTimeout(function timeout() {
						self.acceptRequest(chatAlertId, chatId, clientName);

						return;
					}, 1000);

					return;
				}
			});

			return;
		};

		this.sendMessage = function sendMessage(event, sendClick) {
			var self              = this,
				$chat_message_box = this.getComposer();

			event.stopPropagation();

			if ((event.keyCode === 13 || sendClick) && $chat_message_box.val().trim() !== '') {
				this.resetInactivityTimeout(this.tabId);

				jQuery.ajax({
					type   : 'POST',
					url    : Adzuki.base_uri + '/Chats/sendRequest',
					data   : 'source=cpCentral&action=agentChatSendMessage&phpSessId=' + Adzuki.php_sess_id + '&chatId=' + this.tabId + '&message=' + encodeURIComponent($chat_message_box.val()),
					success: function success(response) {
						var responseData = JSON.parse(response);

						if (!responseData['success']) {
							self.end(self.tabId);

							return;
						}

						$chat_message_box.val('');

						return;
					},
					error: function error() {
						this.jc = Adzuki.StatusMessage('error', 'Unable to send message. Please try again.');
						return;
					}
				});
			}

			return;
		};

		this.end = function end(chatId, close, clicked) {
			var closeParam,
			    clickedParam;

			if (close === undefined) {
				closeParam = false;
			}
			else {
				closeParam = close;
			}

			if (clicked === undefined) {
				clickedParam = false;
			}
			else {
				clickedParam = clicked;
			}

			if (chatId in this.chats) {
				clearTimeout(this.chats[chatId].requestAcceptTimeout);
				clearTimeout(this.chats[chatId].inactivityTimeout);
			}

			jQuery.ajax({
				type    : 'POST',
				url     : Adzuki.base_uri + '/Chats/sendRequest',
				data    : 'source=cpCentral&action=agentChatEnd&phpSessId=' + Adzuki.php_sess_id + '&chatId=' + chatId + '&close=' + closeParam + '&clicked=' + clickedParam,
				complete: function complete() {
					if (!closeParam) {
						document.getElementById('cpcentral-chat-ended-sound').play();

						if (!document.hasFocus()) {
							Adzuki.TitleAlert('Website visitor has left the chat.');
						}
					}
				}
			});

			return;
		};

		this.active = this.getSessionCookie('active');
		this.dnd = false;
		this.tabId = this.getSessionCookie('tabId');
		this.activeChatId = this.getSessionCookie('activeChatId');
		this.chatStatus = null;
		this.chats = {};
		this.execClearAlert = true;
		this.jc = null;

		this.load(this.tabId);

		self = this;

		$chat_container = jQuery('.chat-sidebar');

		jQuery('.toggle-chat').on('click', function click(e) {
			e.preventDefault();

			if (self.active === 'N/A') {
				self.open();
			}
			else {
				self.close();
			}
		});

		return;
	};

	jQuery(document).ready(function documentReady()
	{
		if (
			(!Adzuki.prod && !Adzuki.dev) ||
			(Adzuki.dev && !Adzuki.dev_chat) ||
			(Adzuki.app !== 'Web' && !Adzuki.cpcentral) ||
			(Adzuki.cpcentral && Adzuki.mobile_login)
		) {
			return;
		}

		if (Adzuki.app === 'Web') {
			Adzuki.ClientChat = new ClientChat();
		}
		else {
			Adzuki.AgentChat = new AgentChat();
		}

	});

}(jQuery, window.Adzuki || {}));
